import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import { QRCode } from "react-qr-svg";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { downloadToPNG, downloadToSVG, downloadToJPEG } from "./DownloadImages";
import PrintComponentAdmin from "./PrintComponentAdmin";
import { Col, Row } from "react-bootstrap";
import { FormControl, MenuItem, Select, InputLabel } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import DownloadPdf from "./DownloadPdf";
import MultipleQrCodePrintByMerchant from "../../vendorDashboardComponents/vendorDashboardEditScreen/NewSubscriptionScreen/CasualDiningManagementScreen/SeatingManagement/PrintQrComponent/MultipleQrCodePrintByMerchant";

const IMAGE_EXPORT_TYPES = [
  { value: 0, name: ".jpeg" },
  { value: 1, name: ".png" },
  { value: 2, name: ".svg" },
  {
    value: 3,
    name: ".pdf",
  },
];

function QRCodeMerchants(props) {
  const [state, setState] = useState(false);
  const [export_print, setExportPrint] = useState(0);

  const handleClickOpen = (e) => {
    setCode(e)
    if(e === 0 ||e === 3 || e === 2 || e === 3 ||e === 4){
      setShowbtn(false)
    }else{
      setShowbtn(true)
    }
    setState(true);
    setExportPrint(e);
  };

  const handleClose = (e) => {
    setState(false);
  };

  const [code, setCode] = useState(props?.door_front?.restaurantId ? 0 : props?.table_management_status ? 1 : props?.referral_data ? 2 : props?.webappUrl ? 4 : 3);

  useEffect(() => {
    if(props?.webappUrl){
      setCode(4);
    }else if(props?.referral_data){
      setCode(2)
    }else if(props?.restaurantId){
      setCode(1)
    }else{
      setCode(0)
    }
  },[props?.webappUrl])

  const selectFun = (e) => {
    setCode(e);
    if(e === 0 ||e === 3 || e === 2 || e === 3 || e === 4){
      setShowbtn(false)
    }else{
      setShowbtn(true)
    }
  };
  const [showbtn, setShowbtn] = useState(false);
  const [codes_state, setCodeStatus] = useState(false);
  const [print_status, setPrintStatus] = useState(false);

  const handleCodeSubmit = (e) => {
    if (export_print === 0) {
      setCodeStatus(true);
    } else {
      setPrintStatus(true);
    }
    handleClose();
  };
  const closeDoorFront = () => {
    setCodeStatus(false);
    setPrintStatus(false);
  };
  // const settingCode = (value) => {
  //  if(value === 2){
  //   setCode(2);
  //  }else if(value === 3){
  //   setCode(3);
  //  }
  // }
//  console.log(code,code) 
  return (
    <div>
      <div className="d-flex align-items-center py-3 mt-2 justify-content-center">
        <button
          className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-2"
          type="button"
          onClick={() => handleClickOpen(0)}
        >
          Export
        </button>
        <button
          className="onboarding_button_link_reusable onboarding_button_link_reusable_red_outlined mr-2"
          type="button"
          onClick={(e) => handleClickOpen(1)}
        >
          Print
        </button>
        {props.notDisplay ? (
          <></>
        ) : (
          <MultipleQrCodePrintByMerchant
            qrFrom={"TABLE"}
            setQrTableData={
              props?.table_management_data?.table &&
              props?.table_management_data?.table
            }
            actionBy={"SUPERADMIN"}
            adminVendorId={props?.table_management_data?.vendor_id}
            restaurantData={props?.restaurantData}
          />
        )}
      </div>
      <Dialog
        open={state}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {export_print === 0 ? "Export" : "Print"} QR code
        </DialogTitle>
        <DialogContent>
          <div className="mt-2 mb-3 f18-500">
            Select one relevant option from below
          </div>
          <div className="row w-75">
            {[
              { value: 0, name: "Door Front" },
              // { value: 1, name: "Table number" },
              { value: 2, name: "Referral" },
              { value: 4, name: "Webapp" },
              {
                value: 3,
                name: `${export_print === 0 ? "Export All" : "Room Number"} `,
              },
            ].map((e, index) => {
              const disa =
                e.value === 0
                  ? props?.door_front?.restaurantId
                    ? false
                    : true
                  : e.value === 1
                  ? props?.table_management_status
                    ? false
                    : true
                  : e.value === 2
                  ? props?.referral_data
                    ? false
                    : true
                  : e.value === 4 
                  ? props?.webappUrl 
                    ? false 
                    : true  
                  : e.value === 3
                  ? export_print === 0 && !props?.noAll
                    ? false
                    : true
                  : false;
             
              return disa ? null : (
                <div className="col-6" key={index}>
                  <div
                    className="enCheckWithText "
                    key={index}
                    onClick={() => (disa ? {} : selectFun(e.value))}
                    disabled={disa}
                  >
                    <input
                      type="checkbox"
                      checked={e.value === code ? true : false}
                      disabled={disa}
                      style={{ cursor: disa ? "no-drop" : "pointer" }}
                    />
                    <label>{e.name}</label>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="d-flex align-items-center py-3 mt-4">
            <div className="mr-3">
              <button
                className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                type="button"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
            
            <button
              className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              type="button"
              onClick={handleCodeSubmit}
              disabled={showbtn}
            >
              Confirm
            </button>
          </div>
        </DialogContent>
      </Dialog>

      <QRCodePrint
        open={print_status}
        handleClose={closeDoorFront}
        export_print={export_print}
        code={code}
        restaurantId={props?.restaurantId}
        data={
          code === 0
            ? props?.door_front || { status: false }
            : code === 1
            ? props?.table_management_data || { status: false }
            : code === 2
            ? props?.referral_data || { status: false }
            : code === 4 
            ? props?.webappUrl || { status: false }
            : { status: false }
        }
        handleCodeSubmit={handleCodeSubmit}
        restaurantLogo={props.restaurantLogo}
        restaurantName={props.restaurantName}
      />
      <QRCodeExport
        open={codes_state}
        setCode={(e) => setCode(e)}
        handleClose={closeDoorFront}
        export_print={export_print}
        code={code}
        restaurantId={props?.restaurantId}
        door_front={props.door_front}
        table_management_data={props.table_management_data}
        referral_data={props.referral_data}
        webappUrl={props?.webappUrl}
        handleCodeSubmit={handleCodeSubmit}
        restaurantLogo={props.restaurantLogo}
        restaurantName={props.restaurantName}
      />
    </div>
  );
}

export default QRCodeMerchants;

function QRCodePrint(props) {
  const [size, setSize] = useState(3);
  const [activeFloor, setFloorTable] = useState("");
  const onChangeDashboardTableFloorNumber = (e) =>
    setFloorTable(e.target.value);

  const [tablesBetween, setTablesBetween] = useState({
    start: "",
    end: "",
    start_index: false,
    end_index: false,
  });
  const onChangeTablesBetweenStart = (e) => {
    let index = props?.data?.table?.findIndex(
      (value) => value._id === e.target.value._id
    );
    setTablesBetween({
      ...tablesBetween,
      start: e.target.value,
      start_index: index,
    });
  };
  const onChangeTablesBetweenEnd = (e) => {
    let index = props?.data?.table?.findIndex(
      (value) => value._id === e.target.value._id
    );
    setTablesBetween({
      ...tablesBetween,
      end: e.target.value,
      end_index: index,
    });
  };
  const [all, setAll] = useState(false);
  const setAllFun = (e) => {
    if (!all) {
      setTablesBetween({
        start: "",
        end: "",
        start_index: false,
        end_index: false,
      });
    }
    setAll(!all);
  };

  let printData = [];

  if (props.code === 1) {
    if (all) {
      printData =
        props?.data?.table.map((data, index) => {
          return {
            restaurant_id: props?.data?.restaurant_id,
            table_number: data.table_number,
            type: "table_management",
            vendor_id: props?.data?.vendor_id,
          };
        }) || [];
    } else if (tablesBetween.end_index) {
      printData = props?.data?.table?.filter((item, index) => {
        return (
          index >= tablesBetween.start_index && index <= tablesBetween.end_index
        );
      });
      printData =
        printData.map((data, index) => {
          return {
            restaurant_id: props?.data?.restaurant_id,
            table_number: data.table_number,
            type: "table_management",
            vendor_id: props?.data?.vendor_id,
          };
        }) || [];
    }
  } else {
    printData = [props?.data];
  }

  const [qrcodeType, setQrCodeType] = useState("Sticker");

  return (
    <div>
      <Dialog
        open={props?.open || false}
        onClose={props.handleClose}
        fullWidth
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="d-flex justify-content-between">
            <div>
              Print Preview_
              {props.code === 0
                ? "Door Front"
                : props.code === 1
                ? "Table Management"
                : props.code === 2
                ? "Referrals"
                : props.code === 4
                ? "Webapp"
                : ""}
            </div>
            <div className="ml-4">
              <IconButton
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  color: "black",
                }}
                aria-label="Close"
                onClick={props.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {props.code === 1 && (
            <>
              <Row>
                <Col md={5}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel id="demo-simple-select-label-Floor">
                      Floor
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label-Floor"
                      id="demo-simple-select-Floor"
                      value={activeFloor}
                      onChange={onChangeDashboardTableFloorNumber}
                      inputProps={{
                        name: "floor",
                      }}
                      label="Floor"
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {props?.data?.floors &&
                        props?.data?.floors.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item?.floor_number || ""} - {item?.area || ""}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  <div className="f10-400 opacity5 mt-1">
                    (Select Floor from Above)
                  </div>
                </Col>
              </Row>
              <div className="f14-500 mt-4 mb-2">Select Tables</div>
              <Row className="align-items-center">
                <Col md={5}>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel id="demo-simple-select-label-From">
                      From
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label-From"
                      id="demo-simple-select-From"
                      value={tablesBetween.start}
                      onChange={onChangeTablesBetweenStart}
                      inputProps={{
                        name: "table_start",
                      }}
                      label="From"
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {props?.data?.table &&
                        props?.data?.table
                          .filter(
                            (e) =>
                              e?.active === true &&
                              e?.floor_number?.toLowerCase() ===
                                activeFloor?.floor_number?.toLowerCase() &&
                              e?.area?.toLowerCase() ===
                                activeFloor?.area?.toLowerCase() &&
                              e._id !== tablesBetween.end._id
                          )
                          .map((item, index) =>
                            tablesBetween.end_index ? (
                              index < tablesBetween.end_index && (
                                <MenuItem key={index} value={item}>
                                  {item?.table_number || ""}
                                </MenuItem>
                              )
                            ) : (
                              // )
                              <MenuItem key={index} value={item}>
                                {item?.table_number || ""}
                              </MenuItem>
                            )
                          )}
                    </Select>
                  </FormControl>
                </Col>
                <Col md={5}>
                  <FormControl
                    variant="outlined"
                    className={"w-100"}
                    disabled={tablesBetween.start ? false : true}
                  >
                    <InputLabel id="demo-simple-select-label-To">To</InputLabel>
                    <Select
                      labelId="demo-simple-select-label-To"
                      id="demo-simple-select-To"
                      value={tablesBetween.end}
                      onChange={onChangeTablesBetweenEnd}
                      inputProps={{
                        name: "table_end",
                      }}
                      label="To"
                      IconComponent={KeyboardArrowDownIcon}
                      disabled={tablesBetween.start ? false : true}
                    >
                      {props?.data?.table &&
                        props?.data?.table
                          .filter(
                            (e) =>
                              e?.active === true &&
                              e?.floor_number?.toLowerCase() ===
                                activeFloor?.floor_number?.toLowerCase() &&
                              e?.area?.toLowerCase() ===
                                activeFloor?.area?.toLowerCase() &&
                              e._id !== tablesBetween.start.id
                          )
                          .map((item, index) => {
                            return tablesBetween.start_index ? (
                              index >= tablesBetween.start_index && (
                                <MenuItem key={index} value={item}>
                                  {item?.table_number || ""}
                                </MenuItem>
                              )
                            ) : (
                              <MenuItem key={index} value={item}>
                                {item?.table_number || ""}
                              </MenuItem>
                            );
                          })}
                    </Select>
                  </FormControl>
                </Col>
                <Col md={2}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 mr-2">All</div>
                    <div>
                      <Toggle
                        checked={all}
                        toggleFunction={(e) => setAllFun(e)}
                      />
                    </div>
                  </div>
                </Col>
                <Col md={5}>
                  <div className="f14-500 mt-4 mb-2">QR Code Type</div>
                  <FormControl variant="outlined" className={"w-100"}>
                    <InputLabel id="demo-simple-select-label">
                      QR Code Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={qrcodeType}
                      onChange={(e) => setQrCodeType(e.target.value)}
                      inputProps={{
                        name: "qr_code_type",
                      }}
                      label="QR Code Type"
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <MenuItem value={"Sticker"}>Sticker</MenuItem>
                      <MenuItem value={"TableTentCard"}>
                        Table Tent Card
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Col>
              </Row>

              {/* <div className="mt-3">
              <div className="f12-500">A4 (11.69 x 8.26 inches)</div>
              <div
                style={{ border: "2px solid #212121", background: "#E5E5E5" }}
              >
                <Row
                  className="m-2 qrPript-multiple"
                  id="qrPript-multiple"
                  style={{
                    background: "#FFFFFF",
                    height: "300px",
                    overflowY: "scroll",
                  }}
                >
                  {props?.data?.table.map((item, index) => {
                    if (all) {
                      return (
                        <Col md={4}>
                          <div className="qrPript pr-5 m-0" id="qrPript">
                            <div>
                              <QRCode
                                bgColor="#FFFFFF"
                                fgColor="#000000"
                                level="H"
                                value={
                                  JSON.stringify({
                                    id: item._id,
                                    table_number: item.table_number,
                                  }) || "{ status: false }"
                                }
                              />
                            </div>
                          </div>
                        </Col>
                      );
                    } else {
                      if (
                        tablesBetween.start_index &&
                        tablesBetween.end_index &&
                        index >= tablesBetween.start_index &&
                        index <= tablesBetween.end_index
                      ) {
                        return (
                          <Col md={4}>
                            <div className="qrPript pr-5 m-0" id="qrPript">
                              <div>
                                <QRCode
                                  bgColor="#FFFFFF"
                                  fgColor="#000000"
                                  level="H"
                                  value={
                                    JSON.stringify({
                                      id: item._id,
                                      table_number: item.table_number,
                                    }) || "{ status: false }"
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        );
                      } else {
                        return null;
                      }
                    }
                  })}
                </Row>
              </div>
            </div> */}
            </>
          )}
          <div className="mt-3 mb-3 d-flex align-items-center">
            {[
              // { id: 1, title: "1 x 1 in" },
              { id: 2, title: "1.5 x 1.5 in" },
              { id: 3, title: "2 x 2 in (Default Size)" },
            ].map((e, index) => (
              <div
                key={index}
                className={` mr-3 ${
                  e.id === size ? `f12-700` : `text-secondary f12-400`
                }`}
                style={{
                  curser: "pointer",
                  color: e.id === size ? "red" : "inherit",
                }}
                onClick={() => {
                  setSize(e.id);
                }}
              >
                {e.title}
              </div>
            ))}
          </div>
          <hr />
          <div className="f12-500 mb-3">A4 (11.69 x 8.26 inches)</div>
          {printData.length > 0 ? (
            <div className="f12-500 mt-1 mb-2">Print Preview</div>
          ) : (
            <></>
          )}
          {printData.length > 0 ? (
            <PrintComponentAdmin
              size={size * 50}
              qrData={printData}
              setOpenPrintPreview={props.handleClose}
              qrCodeType={qrcodeType}
              restaurantLogo={props.restaurantLogo}
              restaurantName={props.restaurantName}
            />
          ) : (
            <></>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

function QRCodeExport(props) {
  const [types_model, setTypeModel] = useState(false);

  const onSubmitOpenType = () => {
    setTypeModel(true);
    props.handleClose();
  };

  const closeModelType = () => {
    setTypeModel(false);
    setDownStatus(0);
  };

  const [download_status, setDownStatus] = useState(0);
  const [export_value, setExportValue] = useState(0);

  const onExport = (export_type) => {
    setExportValue(export_type);
    props.handleCodeSubmit();
    closeModelType();
    setDownStatus(1);
    setTimeout(() => {
      let image = document.getElementById("qrPript");
      if (props.code === 1) {
        image = document.getElementById("qrPript-multiple");
      }
      if (props.code === 3) {
        // Export all
        for (let i = 0; i < 3; i++) {
          props.setCode(i);
          setTimeout(async () => {
            if (export_type === 0) {
              await downloadToJPEG(
                image,
                `${props?.restaurantId}-${export_type}_JPEG`,
                onSuccess
              );
            } else if (export_type === 1) {
              await downloadToPNG(
                image,
                `${props?.restaurantId}-${export_type}_PNG`,
                onSuccess
              );
            } else if (export_type === 2) {
              await downloadToSVG(
                image,
                `${props?.restaurantId}-${export_type}_SVG`,
                onSuccess
              );
            } else if (export_type === 3) {
              // downloadToPNG(image, `${props?.restaurantId}-${export_type}_PDF`, onSuccess);
            }
          }, 1000);
        }
      } else {
        //  Export individual
        if (export_type === 0) {
          downloadToJPEG(image, `${props?.restaurantId}_JPEG`, onSuccess);
        } else if (export_type === 1) {
          downloadToPNG(image, `${props?.restaurantId}_PNG`, onSuccess);
        } else if (export_type === 2) {
          downloadToSVG(image, `${props?.restaurantId}_SVG`, onSuccess);
        } else if (export_type === 3) {
          // downloadToPNG(image, `${props?.restaurantId}`, onSuccess);
        }
      }
    }, 1000);
  };

  const onSuccess = (e) => {
    setDownStatus(2);
  };
  const [activeFloor, setFloorTable] = useState("");
  const onChangeDashboardTableFloorNumber = (e) =>
    setFloorTable(e.target.value);

  const [tablesBetween, setTablesBetween] = useState({
    start: "",
    end: "",
    start_index: false,
    end_index: false,
  });
  const onChangeTablesBetweenStart = (e) => {
    let index = props?.table_management_data?.table?.findIndex(
      (value) => value._id === e.target.value._id
    );
    setTablesBetween({
      ...tablesBetween,
      start: e.target.value,
      start_index: index,
    });
  };
  const onChangeTablesBetweenEnd = (e) => {
    let index = props?.table_management_data?.table?.findIndex(
      (value) => value._id === e.target.value._id
    );
    setTablesBetween({
      ...tablesBetween,
      end: e.target.value,
      end_index: index,
    });
  };
  const [all, setAll] = useState(false);
  // const [size, setSize] = useState(0);
  let data =
    props?.code === 0
      ? props?.door_front || { status: false }
      : props?.code === 1
      ? props?.table_management_data || { status: false }
      : props?.code === 2
      ? props?.referral_data || { status: false } 
      : props?.code === 4
      ? props?.webappUrl || { status: false }
      : { status: false };
  return (
    <div>
      <Dialog
        open={props?.open || false}
        // onClose={props.handleClose}
        onClose={() => {
          setDownStatus(0);
          props.handleClose();
        }}
        aria-labelledby="alert-dialog-title"
        fullWidth={props.code === 1 ? true : false}
        maxWidth={props.code === 1 ? "md" : false}
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="d-flex justify-content-between">
            <div>
              Size Preview_
              {props.code === 0
                ? "Door Front"
                : props.code === 1
                ? "Table Management"
                : props.code === 2
                ? "Referrals"
                : props.code === 4
                ? "Webapp"
                : ""}
            </div>
            <div className="ml-4">
              <IconButton
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  color: "black",
                }}
                aria-label="Close"
                onClick={props.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          {download_status === 1 && (
            <div className="text-center text-warning f14-500 text-blinking">
              Download inprogress...
            </div>
          )}
          {download_status === 2 && (
            <div className="text-center text-success f14-500">
              Download success..!
            </div>
          )}
          {export_value != 3 && (
            <>
              {props.code === 1 ? (
                <>
                  <Row>
                    <Col md={5}>
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel id="demo-simple-select-label-Floor">
                          Floor
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label-Floor"
                          id="demo-simple-select-Floor"
                          value={activeFloor}
                          onChange={onChangeDashboardTableFloorNumber}
                          inputProps={{
                            name: "floor",
                          }}
                          label="Floor"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {props?.table_management_data?.floors &&
                            props?.table_management_data?.floors.map(
                              (item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item?.floor_number || ""} -{" "}
                                  {item?.area || ""}
                                </MenuItem>
                              )
                            )}
                        </Select>
                      </FormControl>
                      <div className="f10-400 opacity5 mt-1">
                        (Select Floor from Above)
                      </div>
                    </Col>
                  </Row>

                  <div className="f14-500 mt-4 mb-2">Select Tables</div>
                  <Row className="align-items-center">
                    <Col md={5}>
                      <FormControl variant="outlined" className={"w-100"}>
                        <InputLabel id="demo-simple-select-label-From">
                          From
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label-From"
                          id="demo-simple-select-From"
                          value={tablesBetween.start}
                          onChange={onChangeTablesBetweenStart}
                          inputProps={{
                            name: "table_start",
                          }}
                          label="From"
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {props?.table_management_data?.table &&
                            props?.table_management_data?.table
                              .filter(
                                (e) =>
                                  e?.active === true &&
                                  e?.floor_number?.toLowerCase() ===
                                    activeFloor?.floor_number?.toLowerCase() &&
                                  e?.area?.toLowerCase() ===
                                    activeFloor?.area?.toLowerCase() &&
                                  e._id !== tablesBetween.end._id
                              )
                              .map((item, index) =>
                                tablesBetween.end_index ? (
                                  index < tablesBetween.end_index && (
                                    <MenuItem key={index} value={item}>
                                      {item?.table_number || ""}
                                    </MenuItem>
                                  )
                                ) : (
                                  // )
                                  <MenuItem key={index} value={item}>
                                    {item?.table_number || ""}
                                  </MenuItem>
                                )
                              )}
                        </Select>
                      </FormControl>
                    </Col>

                    <Col md={5}>
                      <FormControl
                        variant="outlined"
                        className={"w-100"}
                        disabled={tablesBetween.start ? false : true}
                      >
                        <InputLabel id="demo-simple-select-label-To">
                          To
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label-To"
                          id="demo-simple-select-To"
                          value={tablesBetween.end}
                          onChange={onChangeTablesBetweenEnd}
                          inputProps={{
                            name: "table_end",
                          }}
                          label="To"
                          IconComponent={KeyboardArrowDownIcon}
                          disabled={tablesBetween.start ? false : true}
                        >
                          {props?.table_management_data?.table &&
                            props?.table_management_data?.table
                              .filter(
                                (e) =>
                                  e?.active === true &&
                                  e?.floor_number?.toLowerCase() ===
                                    activeFloor?.floor_number?.toLowerCase() &&
                                  e?.area?.toLowerCase() ===
                                    activeFloor?.area?.toLowerCase() &&
                                  e._id !== tablesBetween.start.id
                              )
                              .map((item, index) => {
                                return tablesBetween.start_index ? (
                                  index >= tablesBetween.start_index && (
                                    <MenuItem key={index} value={item}>
                                      {item?.table_number || ""}
                                    </MenuItem>
                                  )
                                ) : (
                                  <MenuItem key={index} value={item}>
                                    {item?.table_number || ""}
                                  </MenuItem>
                                );
                              })}
                        </Select>
                      </FormControl>
                    </Col>
                    <Col md={2}>
                      <div className="d-flex align-items-center">
                        <div className="f12-500 mr-2">All</div>
                        <div>
                          <Toggle
                            checked={all}
                            toggleFunction={(e) => setAll(!all)}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* <div className="mt-3 d-flex align-items-center">
                {[
                  { id: 0, title: "1 x 1 in (Default Size)" },
                  { id: 1, title: "1.5 x 1.5 in" },
                  { id: 2, title: "2 x 2 in" },
                ].map((e, index) => (
                  <div
                    key={index}
                    className={` mr-3 ${
                      e.id === size
                        ? `text-danger f12-700`
                        : `text-secondary f12-400`
                    }`}
                    onClick={() => {
                      setSize(e.id);
                    }}
                  >
                    {e.title}
                  </div>
                ))}
              </div>
              <hr /> */}
                  <div className="mt-3">
                    <div className="f12-500 mb-2">A4 (11.69 x 8.26 inches)</div>
                    <div
                      style={{
                        border: "2px solid #212121",
                        background: "#E5E5E5",
                      }}
                    >
                      <Row
                        className="m-2 qrPript-multiple"
                        id="qrPript-multiple"
                        style={{
                          background: "#FFFFFF",
                          height: "300px",
                          overflowY: "scroll",
                        }}
                      >
                        {props?.table_management_data?.table &&
                          props?.table_management_data?.table.map(
                            (item, index) => {
                              if (all) {
                                return (
                                  <Col md={4}>
                                    <div
                                      className="qrPript pr-5 m-0"
                                      id="qrPript"
                                    >
                                      <div>
                                        <QRCode
                                          bgColor="#FFFFFF"
                                          fgColor="#000000"
                                          level="H"
                                          value={
                                            JSON.stringify({
                                              restaurant_id:
                                                props?.table_management_data
                                                  ?.restaurant_id,
                                              table_number: item.table_number,
                                              type: "table_management",
                                              vendor_id:
                                                props?.table_management_data
                                                  ?.vendor_id,
                                            }) || "{ status: false }"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                );
                              } else {
                                if (
                                  tablesBetween?.end_index &&
                                  index >= tablesBetween?.start_index &&
                                  index <= tablesBetween?.end_index
                                ) {
                                  return (
                                    <Col md={4}>
                                      <div
                                        className="qrPript pr-5 m-0"
                                        id="qrPript"
                                      >
                                        <div>
                                          <QRCode
                                            bgColor="#FFFFFF"
                                            fgColor="#000000"
                                            level="H"
                                            value={
                                              JSON.stringify({
                                                restaurant_id:
                                                  props?.table_management_data
                                                    ?.restaurant_id,
                                                table_number: item.table_number,
                                                type: "table_management",
                                                vendor_id:
                                                  props?.table_management_data
                                                    ?.vendor_id,
                                              }) || "{ status: false }"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            }
                          )}

                        <Col
                          xs={12}
                          align="center"
                          className="text-center f12-500"
                        >
                          {all ? (
                            <>
                              {" "}
                              {props?.table_management_data?.table?.length >
                                6 &&
                                `Page ${parseInt(
                                  props?.table_management_data?.table?.length /
                                    6
                                )} of ${parseInt(
                                  props?.table_management_data?.table?.length /
                                    6
                                )}`}
                            </>
                          ) : (
                            <>
                              {props?.table_management_data?.table?.filter(
                                (item, index) =>
                                  tablesBetween?.end_index &&
                                  index >= tablesBetween?.start_index &&
                                  index <= tablesBetween?.end_index
                              )?.length > 6 &&
                                `Page ${parseInt(
                                  props?.table_management_data?.table?.length /
                                    6
                                )} of ${parseInt(
                                  props?.table_management_data?.table?.length /
                                    6
                                )}`}
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="qrPript pr-5 m-0" id="qrPript">
                    <div>
                      <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                        value={
                          typeof data === "object"
                            ? JSON.stringify(data)
                            : data
                            ? data
                            : JSON.stringify({ status: false })
                        }
                      />
                    </div>
                  </div>
                  {/* <div className="f14-500 mt-2 ml-4">10 x 10 inches</div> */}
                </>
              )}{" "}
            </>
          )}
          <div className="d-flex align-items-center py-3 mt-4">
            {export_value === 3 ? (
              <DownloadPdf
                cancel={
                  <div className="mr-3">
                    {" "}
                    <button
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                      type="button"
                      // onClick={props.handleClose}
                      onClick={() => {
                        setDownStatus(0);
                        props.handleClose();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                }
                title={`${props?.restaurantId}_PDF`}
                image={
                  <div className="qrPript pr-5 m-0" id="qrPript">
                    <div>
                      <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                        value={
                          JSON.stringify(props?.data) || "{ status: false }"
                        }
                      />
                    </div>
                  </div>
                }
                download={export_value === 3 ? true : false}
                onComplete={onSuccess}
              />
            ) : (
              <>
                <div className="mr-3">
                  {" "}
                  <button
                    className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    type="button"
                    // onClick={props.handleClose}
                    onClick={() => {
                      setDownStatus(0);
                      props.handleClose();
                    }}
                  >
                    Cancel
                  </button>
                </div>
                <button
                  className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  type="button"
                  onClick={onSubmitOpenType}
                >
                  {props?.export_print === 0 ? "Export" : "Print"}
                </button>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <QRCodeExportType
        open={types_model}
        handleClose={closeModelType}
        onExport={onExport}
      />
    </div>
  );
}

export function QRCodeExportType(props) {
  const [type, settype] = useState(0);

  const selectFun = (e) => {
    settype(e);
  };

  return (
    <div>
      <Dialog
        open={props?.open || false}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="d-flex justify-content-between">
            <div>Export Type</div>
            <div className="ml-4">
              <IconButton
                style={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  color: "black",
                }}
                aria-label="Close"
                onClick={props.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="mt-2 mb-3 f18-500">
            Select one relevant option from below
          </div>
          <div className="row w-75">
            {IMAGE_EXPORT_TYPES.map((e, index) => (
              <div className="col-4" key={index}>
                <div
                  className="enCheckWithText "
                  key={index}
                  onClick={() => selectFun(e.value)}
                >
                  <input
                    type="checkbox"
                    checked={e.value === type ? true : false}
                  />
                  <label>{e.name}</label>
                </div>
              </div>
            ))}
          </div>{" "}
          <div className="d-flex align-items-center py-3 mt-4">
            <div className="mr-3">
              {" "}
              <button
                className="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                type="button"
                onClick={props.handleClose}
              >
                Cancel
              </button>
            </div>

            <button
              className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              type="button"
              onClick={() => props.onExport(type)}
            >
              {props?.export_print === 0 ? "Export" : "Print"}
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
